<template>
  <div class="layout">
    <home @click-logo="handleLogoClicked">
      <template #logo>
        <span>DMS for Redis</span>
      </template>

      <!--<template #aside>
        <layout-aside></layout-aside>
      </template>-->
    </home>
  </div>
</template>

<script>
import Home from '@/views/layouts/Home';

export default {
  name: 'Layout',

  components: {
    Home
  },

  methods: {
    handleLogoClicked() {
      this.$router.push({ name: 'RedisIndex', query: this.$route.query });
    }
  }
};
</script>
